import React from 'react';
import styled from 'styled-components';
import {
  Button as BaseButton,
  InputAdornment,
  TextField,
  FormControl,
  Select as BaseSelect,
  MenuItem,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';

import { withProps } from '../../../libs/react-utils';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  margin-bottom: 25px;
`;

Header.Left = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

Header.Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Button = styled(BaseButton)`
  padding: 12px 14px !important;
  font-size: 16px !important;
  font-family: Poppins;
  line-height: 1 !important;
  color: ${({ textColor }) => textColor || '#ffffff'} !important;
  background-color: ${({ background }) => background} !important;
  border: ${({ border }) => border || 'none'} !important;
  border-radius: 13px !important;

  &:disabled {
    color: #6c7075 !important;
    background-color: #cacaca !important;
  }

  // Override global default styles which set Poppins as font-family for everything (which is pretty bad!)
  .MuiButton-label {
    font-family: 'Montserrat', sans-serif !important;
  }
`;

export const Tab = styled.span`
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 26px;
  color: #212121;
`;

export const CreateButton = withProps(
  {
    textColor: '#004BC4',
    background: 'transparent',
    border: '1px solid #004BC4',
  },
  Button
);

export const ArchiveList = styled.ul`
  margin: 0;
  padding-left: 12px;
  max-height: 200px;
  overflow-y: auto;
`;

ArchiveList.Item = 'li';

export const SearchInput = styled(TextField).attrs({
  variant: 'outlined',
  size: 'small',
  InputProps: {
    startAdornment: (
      <InputAdornment position="start">
        <Search />
      </InputAdornment>
    ),
  },
})`
  width: 320px !important;

  .MuiInputBase-root {
    color: #1f1f1f;
    font-size: 14px;
    gap: 4px;
    border-radius: 13px;
  }

  .MuiInputBase-input {
    &::placeholder {
      color: #1f1f1f;
      font-family: Poppins;
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
    }
  }

  .MuiSvgIcon-root {
    font-size: 20px;
  }

  .MuiOutlinedInput-notchedOutline {
    transition: border-color 250ms ease-in;

    &:is(:hover, :focus, :active) {
      transition-timing-function: ease-out;
    }

    &:not(:hover, :focus, :active) {
      border-color: #d4d7d9;
    }
  }
`;

export const ChangeStatusDropdown = styled(FormControl)`
  width: 210px !important;
  height: 44px;

  .MuiInputBase-root {
    border-radius: 13px;
    font-family: Poppins;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    color: #1f1f1f;
    height: 44px;
    background-color: transparent !important;

    &:hover,
    &:focus,
    &.Mui-focused {
      background-color: transparent !important;
    }
  }

  .MuiSelect-select {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: #d4d7d9;
    border-width: 1px;
  }
`;

ChangeStatusDropdown.Select = styled(BaseSelect)`
  background-color: transparent !important;

  &:hover,
  &:focus,
  &.Mui-focused {
    background-color: transparent !important;
  }

  .MuiSelect-select {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: transparent !important;
  }
`;

ChangeStatusDropdown.MenuItem = MenuItem;

ChangeStatusDropdown.ValueContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TableWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

TableWrapper.Toolbar = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 25px;
`;

TableWrapper.Content = styled.div`
  flex-grow: 1;
  transition: margin-top 0.3s ease-in;
`;

export const InfoBubbleWrapper = styled.div`
  max-height: ${props => (props.isVisible ? '500px' : '0')};
  opacity: ${props => (props.isVisible ? '1' : '0')};
  margin-bottom: ${props => (props.isVisible ? '0' : '-20px')};
  overflow: hidden;
  transition: max-height 0.3s ease-in, opacity 0.3s ease-in,
    margin-bottom 0.3s ease-in;
`;

export const InfoBubble = styled.div`
  background-color: #f8f8f8;
  border-radius: 16px;
  font-size: 14px;
  padding: 12px 20px;
  position: relative;
  width: 800px;
`;

InfoBubble.Content = styled.div`
  display: flex;
  gap: 12px;
`;

InfoBubble.Text = styled.p`
  margin: 0;
  font-family: Poppins;
  font-weight: 400;
  font-style: Regular;
  color: #212121;
  line-height: 1.5;
  flex: 1;
`;

InfoBubble.CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  color: #6c757d;
  border-radius: 4px;
  transition: background-color 0.2s;
  width: 24px;
  height: 24px;

  &:hover {
    background-color: #e9ecef;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
